import createIcon from '../../createIcon';

/**
 * @component @name KingBed
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTBWN0MyMCA1LjkgMTkuMSA1IDE4IDVINkM0LjkgNSA0IDUuOSA0IDdWMTBDMi45IDEwIDIgMTAuOSAyIDEyVjE3SDMuMzNMNCAxOUg1TDUuNjcgMTdIMTguMzRMMTkgMTlIMjBMMjAuNjcgMTdIMjJWMTJDMjIgMTAuOSAyMS4xIDEwIDIwIDEwWk0xMSAxMEg2VjdIMTFWMTBaTTE4IDEwSDEzVjdIMThWMTBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KingBed = createIcon('KingBed', [
  [
    'path',
    {
      d: 'M20 10V7C20 5.9 19.1 5 18 5H6C4.9 5 4 5.9 4 7V10C2.9 10 2 10.9 2 12V17H3.33L4 19H5L5.67 17H18.34L19 19H20L20.67 17H22V12C22 10.9 21.1 10 20 10ZM11 10H6V7H11V10ZM18 10H13V7H18V10Z',
      key: 'wq3hic',
    },
  ],
]);

export default KingBed;
